import React from "react";
import Pagination from "react-bootstrap/Pagination";
import { LinkContainer } from 'react-router-bootstrap'


export default function CustomPagination(props){
  let {pageIndex,pages} =props;

  if (pages.length>0){
    return(
      <Pagination>
        <LinkContainer onClick={()=>window.scrollTo(0,0)} isActive={()=>false}  to={props.getPaginationLink(Math.max(1,pageIndex-1))}>
          <Pagination.Prev/>
        </LinkContainer>
        {pageIndex!==1 &&
          <LinkContainer onClick={()=>window.scrollTo(0,0)} isActive={()=>false} to={props.getPaginationLink(1)}>
            <Pagination.Item>1</Pagination.Item>
          </LinkContainer>
        }


        {pageIndex>3&&
          <Pagination.Ellipsis/>
        }

        {pageIndex>2 &&
          <LinkContainer onClick={()=>window.scrollTo(0,0)} isActive={()=>false}  to={props.getPaginationLink(pageIndex-1)}>
            <Pagination.Item >
              {pageIndex-1}
            </Pagination.Item>
          </LinkContainer>
        }

        <LinkContainer onClick={()=>window.scrollTo(0,0)} isActive={()=>true}  to={props.getPaginationLink(pageIndex)}>
          <Pagination.Item >
            {pageIndex}
          </Pagination.Item>
        </LinkContainer>

        {pageIndex+1 < pages.length &&
          <LinkContainer onClick={()=>window.scrollTo(0,0)} isActive={()=>false}  to={props.getPaginationLink(pageIndex+1)}>
            <Pagination.Item >
              {(pageIndex+1)}
            </Pagination.Item>
          </LinkContainer>
        }

        {pageIndex+2<pages.length &&
          <Pagination.Ellipsis/>
        }
        {pageIndex!==pages.length &&
          <LinkContainer onClick={()=>window.scrollTo(0,0)} isActive={()=>false}  to={props.getPaginationLink(pages.length)}>
            <Pagination.Item>{pages.length}</Pagination.Item>
          </LinkContainer>
        }


        <LinkContainer isActive={()=>false} onClick={()=>window.scrollTo(0,0)} to={props.getPaginationLink(Math.min(pages.length,pageIndex+1))}>
          <Pagination.Next />
        </LinkContainer>
      </Pagination>
    );
  }
  else{
    return(null);
  }
}
